const closeShareMenu = (shareRoot) => {
  const toggle = shareRoot.querySelector('[data-share-toggle]');
  const menu = shareRoot.querySelector('[data-share-menu]');

  if (!toggle || !menu) {
    return;
  }

  menu.hidden = true;
  shareRoot.classList.remove('is-open');
  toggle.setAttribute('aria-expanded', 'false');
};

const openShareMenu = (shareRoot, allShareTools) => {
  const toggle = shareRoot.querySelector('[data-share-toggle]');
  const menu = shareRoot.querySelector('[data-share-menu]');

  if (!toggle || !menu) {
    return;
  }

  allShareTools.forEach((otherShareRoot) => {
    if (otherShareRoot !== shareRoot) {
      closeShareMenu(otherShareRoot);
    }
  });

  menu.hidden = false;
  shareRoot.classList.add('is-open');
  toggle.setAttribute('aria-expanded', 'true');
};

export const initShareTools = () => {
  const shareTools = document.querySelectorAll('[data-share-tools]');

  if (!shareTools.length) {
    return;
  }

  shareTools.forEach((shareRoot) => {
    const toggle = shareRoot.querySelector('[data-share-toggle]');
    const menu = shareRoot.querySelector('[data-share-menu]');

    if (!toggle || !menu || toggle.dataset.shareBound === 'true') {
      return;
    }

    toggle.addEventListener('click', (event) => {
      event.preventDefault();

      if (shareRoot.classList.contains('is-open')) {
        closeShareMenu(shareRoot);
        return;
      }

      openShareMenu(shareRoot, shareTools);
    });

    menu.addEventListener('click', (event) => {
      const target = event.target;

      if (!(target instanceof Element) || !target.closest('.annuncio-detail__share-option')) {
        return;
      }

      closeShareMenu(shareRoot);
    });

    toggle.dataset.shareBound = 'true';
  });

  document.addEventListener('click', (event) => {
    const target = event.target;

    if (!(target instanceof Node)) {
      return;
    }

    shareTools.forEach((shareRoot) => {
      if (!shareRoot.contains(target)) {
        closeShareMenu(shareRoot);
      }
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') {
      return;
    }

    shareTools.forEach((shareRoot) => {
      if (!shareRoot.classList.contains('is-open')) {
        return;
      }

      closeShareMenu(shareRoot);
      shareRoot.querySelector('[data-share-toggle]')?.focus();
    });
  });
};